import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  label: {
    textAlign: "left",
    color: "#484a56",
  },
  formTextInput: {
    marginBottom: "0px",
    marginTop: "0px",
  },
  emailInput: {
    boxShadow: "4px 4px 4px 0px #0C38911A",
  },
  mb20: {
    marginBottom: "10px",
  },
  form: {
    marginBottom: "1.5rem",
  },
  alreadyHaveAccountText: {
    marginTop: 20,
    color: "#707070",
    display: "flex",
    whiteSpace: "nowrap",
    alignItems: "center",
    justifyContent: "center",
  },
  loginNow: {
    marginLeft: "5px",
    cursor: "pointer",
    minWidth: 0,
    height: "auto",
    padding: "0 2px",
    backgroundColor: "transparent",
    border: "none",
    width: "auto",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  error: {
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "13.02px",
  },
  loginButtons: {
    gap: theme.spacing(2),
    flexDirection: "column",
    whiteSpace: "nowrap",
  },
  emailLabel: {
    fontWeight: "500",
  },
  buttonWrapper: {
    textTransform: "none",
  },
}));
